export default "assets/example-1.218e13fc5dacd929.png"